import { FC } from 'react';

import { default as Input, MaskInputProps } from './InputMask';

const DateInput: FC<MaskInputProps> = ({
  placeholder = 'mm/dd/yyyy',
  showCalendarIcon,
  ...props
}) => {
  return (
    <Input
      {...props}
      inputMode="numeric"
      mask="__/__/____"
      placeholder={placeholder}
      replacement={{ _: /\d/ }}
      showCalendarIcon={showCalendarIcon}
    />
  );
};

export { DateInput };
